export const buildClientPaymentMethodSave = (clientId, stripePaymentMethodId) => ({
  client_id: clientId,
  stripe_payment_method_id: stripePaymentMethodId,
});

export const buildClientPaymentMethodSetup = (clientId) => ({ client_id: clientId });

export const getSetupIntentClientSecret = (value = {}) => {
  const response = value?.data && typeof value.data === "object" ? value.data : value;
  return typeof response?.client_secret === "string" ? response.client_secret : "";
};

export const getConfirmedSetupIntentId = (result = {}) => (
  result?.setupIntent?.status === "succeeded" && typeof result.setupIntent.id === "string"
    ? result.setupIntent.id
    : ""
);

export const buildClientPaymentMethodConfirmation = (clientId, setupIntentId) => ({
  client_id: clientId,
  setup_intent_id: setupIntentId,
});

export const normalizeSavedCards = (value) => {
  const response = Array.isArray(value?.cards) ? value.cards : value?.data !== undefined ? value.data : value;
  const records = Array.isArray(response) ? response : response && typeof response === "object" ? [response] : [];
  return records
    .filter((record) => record && record.id != null && record.is_active !== false)
    .map((record) => ({
      id: record.id,
      brand: record.brand || "Card",
      last4: record.last4 || "••••",
      stripe_payment_method_id: record.stripe_payment_method_id,
      exp_month: record.exp_month || "",
      exp_year: record.exp_year || "",
      is_default: record.is_default === true,
    }))
    .sort((left, right) => Number(right.is_default) - Number(left.is_default) || Number(left.id) - Number(right.id));
};


const subscriptionCardReasons = {
  provider_unavailable: 'Subscription cards could not be verified right now. Please try again later.',
  subscription_unverified: 'A subscription card could not be verified. It has not been added to Saved cards.',
  card_unavailable: 'A subscription card is no longer available for reuse. You can add a card below.',
  customer_conflict: "A subscription card could not be matched to this client's saved-card account. Contact support.",
  card_removed: 'A subscription card was previously removed and has not been restored.',
  card_owned_elsewhere: 'A subscription card is not available for this client. Contact support.',
  subscription_changed: 'A subscription changed while its card was being checked. Please try again.',
  too_many_subscriptions: 'Not all subscription cards could be checked. Contact support.',
};

export const subscriptionCardNotice = (value) => {
  const result = value?.subscription_card_reconciliation;
  if (!result || !['partial','unavailable'].includes(result.status)) return '';
  const reasons = Array.isArray(result.reasons) ? result.reasons : [];
  return [...new Set(reasons.map(reason => subscriptionCardReasons[reason?.code] || subscriptionCardReasons.provider_unavailable))].join(' ')
    || subscriptionCardReasons.provider_unavailable;
};
